import React, { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";

// HCM Sidebar Links
const HCMNavbarLinks = [
  { path: "/dashboard", title: "Overview" },
  // { path: "/dashboard/admin", title: "Admin" },
  { path: "/dashboard/analytics", title: "Analytics" },
  { path: "/dashboard/applicants", title: "Applicants" },
  { path: "/dashboard/benefits", title: "Benefits" },
  { path: "/dashboard/employee-development", title: "Employee Development" },
  { path: "/dashboard/employee-management", title: "Employee Management" },
  { path: "/dashboard/enterprise", title: "Enterprise" },
  { path: "/dashboard/hr-services", title: "HR Services" },
  { path: "/dashboard/interviews", title: "Interviews" },
  { path: "/dashboard/jobs", title: "Jobs" },
  { path: "/dashboard/learning-and-development", title: "Learning and Development" },
  { path: "/dashboard/messaging", title: "Messaging" },
  { path: "/dashboard/payroll", title: "Payroll" },
  { path: "/dashboard/performance-management", title: "Performance Management" },
  { path: "/dashboard/recruiter", title: "Recruiter" },
  { path: "/dashboard/roles", title: "Roles" },
  { path: "/dashboard/settings", title: "Settings" },
  { path: "/dashboard/time-and-absence", title: "Time and Absence" },
  { path: "/dashboard/users", title: "Users" },
  { path: "/dashboard/work-management", title: "Work Management" },
  { path: "dashboard/subscription", title: "Subscriptions"},
  { path: "dashboard/forms", title: "Forms" },

];

const DashboardSidebar = () => {
  const [isOpen, setIsOpen] = React.useState(false); // State for hover-based open/close

  const handleMouseEnter = () => {
    setIsOpen(true); // Expand sidebar on mouse enter
  };

  const handleMouseLeave = () => {
    setIsOpen(false); // Collapse sidebar on mouse leave
  };

  return (
    <aside
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        width: isOpen ? "200px" : "60px", // Expand or collapse based on hover
        height: "calc(100vh - 60px)", // Start below the header (adjust `60px` to match header height)
        backgroundColor: "#f8f9fa",
        boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)",
        padding: isOpen ? "10px" : "5px", // Adjust padding for compact view
        position: "fixed",
        top: "60px", // Adjust `60px` to match the header height
        left: 0,
        zIndex: 1040, // Ensure sidebar appears above other elements
        transition: "width 0.3s ease, padding 0.3s ease", // Smooth transition
        overflow: "hidden", // Prevent content overflow
      }}
      aria-label="Dashboard Sidebar"
    >
      <h3
        style={{
          marginBottom: "10px",
          color: "#333",
          textAlign: "center",
          display: isOpen ? "block" : "none", // Hide when sidebar is collapsed
          fontSize: "14px", // Smaller font size
        }}
      >
        Dashboard
      </h3>
      <ul
        style={{
          listStyleType: "none",
          padding: 0,
          margin: 0,
        }}
      >
        {HCMNavbarLinks.map(({ path, title }) => (
          <li
            key={path}
            style={{
              marginBottom: "5px", // Reduced spacing between items
              textAlign: isOpen ? "left" : "center", // Center text for compact view
            }}
          >
            <NavLink
              to={path}
              style={({ isActive }) => ({
                textDecoration: "none",
                color: isActive ? "#fff" : "#007bff",
                backgroundColor: isActive ? "#007bff" : "transparent",
                padding: "5px", // Minimal padding for compact view
                borderRadius: "5px",
                display: "block",
                fontWeight: "500",
                fontSize: isOpen ? "12px" : "10px", // Adjust font size for compact view
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                transition: "background-color 0.3s ease, color 0.3s ease",
              })}
              title={title} // Tooltip for compact view
            >
              {isOpen ? title : title.charAt(0)} {/* Full text or initials */}
            </NavLink>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default DashboardSidebar;